// import react from 'react';
import { Spinner } from 'react-bootstrap';








function Loading (){
    return(<>
        <div className='loading-main'>
            <Spinner animation="border" variant="primary" />
        </div>
    </>)
}



export default Loading;